var _rect, _circle, _circle2, _rect2, _circle3, _circle4, _rect3, _circle5, _circle6, _rect4, _circle7, _circle8, _rect5, _circle9, _circle10, _rect6, _circle11, _circle12, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 611,
    viewBox: "0 0 1500 611",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 405,
    width: 209,
    height: 200,
    fill: "#D9F7FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 404.5,
    r: 104.5,
    fill: "url(#paint0_linear_7_38)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 404.5,
    r: 54.5,
    fill: "url(#paint1_linear_7_38)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 405,
    width: 209,
    height: 200,
    fill: "#FFF7A5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 404.5,
    r: 104.5,
    fill: "url(#paint2_linear_7_38)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 404.5,
    r: 54.5,
    fill: "url(#paint3_linear_7_38)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 537,
    y: 305,
    width: 209,
    height: 300,
    fill: "#83EEE8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.5,
    cy: 304.5,
    r: 104.5,
    fill: "url(#paint4_linear_7_38)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.5,
    cy: 304.5,
    r: 54.5,
    fill: "url(#paint5_linear_7_38)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 255,
    width: 209,
    height: 350,
    fill: "#96E9FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.5,
    cy: 254.5,
    r: 104.5,
    transform: "rotate(-180 858.5 254.5)",
    fill: "url(#paint6_linear_7_38)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.5,
    cy: 254.5,
    r: 54.5,
    transform: "rotate(-180 858.5 254.5)",
    fill: "url(#paint7_linear_7_38)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 971,
    y: 155,
    width: 209,
    height: 450,
    fill: "#FFC38B"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1075.5,
    cy: 154.5,
    r: 104.5,
    fill: "url(#paint8_linear_7_38)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1075.5,
    cy: 154.5,
    r: 54.5,
    fill: "url(#paint9_linear_7_38)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1188,
    y: 105,
    width: 209,
    height: 500,
    fill: "#E2E0FF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1292.5,
    cy: 104.5,
    r: 104.5,
    fill: "url(#paint10_linear_7_38)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1292.5,
    cy: 104.5,
    r: 54.5,
    fill: "url(#paint11_linear_7_38)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 605,
    width: 1500,
    height: 6,
    rx: 3,
    fill: "url(#paint12_linear_7_38)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_38",
    x1: 103,
    y1: 404.5,
    x2: 312,
    y2: 404.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#39D1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_38",
    x1: 262,
    y1: 404.5,
    x2: 153,
    y2: 404.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#39D1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_38",
    x1: 320,
    y1: 404.5,
    x2: 529,
    y2: 404.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_38",
    x1: 479,
    y1: 404.5,
    x2: 370,
    y2: 404.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7_38",
    x1: 537,
    y1: 304.5,
    x2: 746,
    y2: 304.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#39BEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00827B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7_38",
    x1: 696,
    y1: 304.5,
    x2: 587,
    y2: 304.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#39BEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00827B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7_38",
    x1: 754,
    y1: 254.5,
    x2: 963,
    y2: 254.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#008AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00AEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7_38",
    x1: 913,
    y1: 254.5,
    x2: 804,
    y2: 254.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#008AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00AEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7_38",
    x1: 971,
    y1: 154.5,
    x2: 1180,
    y2: 154.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF8130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF3200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7_38",
    x1: 1130,
    y1: 154.5,
    x2: 1021,
    y2: 154.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF8130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF3200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7_38",
    x1: 1188,
    y1: 104.5,
    x2: 1397,
    y2: 104.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BDBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9896FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7_38",
    x1: 1347,
    y1: 104.5,
    x2: 1238,
    y2: 104.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BDBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9896FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7_38",
    x1: 0,
    y1: 608,
    x2: 1500,
    y2: 608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39D1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00827B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#008AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF3200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9896FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.17f90bc3f1dcd231305ec8f925d6c5bb.svg";
export { ForwardRef as ReactComponent };